import { LabelType } from '@piccolohealth/pbs-common';
import React from 'react';
import { FormStack } from '../../../components/forms/FormStack';
import { HookedFormField } from '../../../components/forms/HookedFormField';
import { HookedInput } from '../../../components/forms/HookedInput';
import { HookedLabelChooser } from '../../../components/forms/HookedLabelChooser';
import { HookedSwitch } from '../../../components/forms/HookedSwitch';
import { HookedTaskRecurrenceSelect } from '../../../components/forms/HookedTaskRecurrenceSelect';

export const ParticipantTaskTemplateForm = () => {
  return (
    <FormStack>
      <HookedFormField name='name' label='Task Name' required>
        <HookedInput name='name' size='sm' placeholder='Enter task name' />
      </HookedFormField>
      <HookedFormField name='requiresDueDate' label='Requires Due Date'>
        <HookedSwitch name='requiresDueDate' />
      </HookedFormField>
      <HookedFormField name='recurrence' label='Recurrence Interval (days)'>
        <HookedTaskRecurrenceSelect name='recurrence' />
      </HookedFormField>
      <HookedFormField name='labelIds' label='Labels'>
        <HookedLabelChooser name='labelIds' type={LabelType.ParticipantTask} />
      </HookedFormField>
    </FormStack>
  );
};
